import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminLayout from "../Components/AdminLayout";
import Dashboard from "./Dashboard";
import AdminUsers from "./AdminUsers";
import AdminOptimizations from "./AdminOptimizations";
import AdminPayments from "./AdminPayments";

const Mainadminroute = () => {
  const token = localStorage.getItem("meeshoadminToken");

  return (
    <Routes>
      {!token ? (
        <>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/*" element={<AdminLogin/>} />
        </>
      ) : (
        <Route element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/*" element={<Dashboard />} />
          <Route path="/users" element={<AdminUsers />} />
          <Route path="/optimizations" element={<AdminOptimizations />} />
          <Route path="payments" element={<AdminPayments />} />
          {/* <Route path="*" element={<Navigate to="dashboard" replace />} /> */}
        </Route>
      )}
    </Routes>
  );
};

export default Mainadminroute;